<template>
  <div class="header__filter">
    <div class="header__filter-item">
      <Dropdown
        :value="view.date_field"
        :disabled="readOnly"
        :show-search="true"
        @input="cambiarCampo"
      >
        <DropdownItem name="Sin fecha" :value="null"></DropdownItem>
        <DropdownItem
          v-for="campo in camposDeFecha"
          :key="campo.id"
          :name="campo.name"
          :value="campo.id"
        ></DropdownItem>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import { camposDeFecha } from '@extras_mg/utils/campos'
import Dropdown from '@baserow/modules/core/components/Dropdown'
import DropdownItem from '@baserow/modules/core/components/DropdownItem'
import { notifyIf } from '@baserow/modules/core/utils/error'

export default {
  name: 'CalendarioViewHeader',
  components: { Dropdown, DropdownItem },
  props: {
    database: { type: Object, required: true },
    view: { type: Object, required: true },
    table: { type: Object, required: true },
    fields: { type: Array, required: true },
    readOnly: { type: Boolean, required: true },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    camposDeFecha() {
      return camposDeFecha(this.fields)
    },
  },
  methods: {
    async cambiarCampo(idCampo) {
      try {
        await this.$store.dispatch('view/update', {
          view: this.view,
          values: { date_field: idCampo },
        })
      } catch (e) {
        notifyIf(e, 'view')
      }
    },
  },
}
</script>
